var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"d-flex justify-content-center",attrs:{"fluid":""}},[_c('VueApexCharts',{attrs:{"width":"450","options":_vm.data.chartOptions,"series":_vm.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }